import { Platform } from 'react-native';
import colors from './colors';
export var textStyle = {
  pageTitle: Platform.select({
    web: {
      fontSize: 21,
      fontFamily: "Montserrat",
      fontWeight: "bold",
      color: '#003087',
      textTransform: 'uppercase'
    },
    default: {
      fontSize: 21,
      fontFamily: "Montserrat",
      fontWeight: "bold",
      color: "#003087"
    }
  }),
  navBarItems: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Regular",
      fontSize: 14,
      color: '#333333'
    },
    default: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 10,
      color: '#333333'
    }
  }),
  topRightNavSection: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Bold",
      fontSize: 14,
      color: '#1B1B1B',
      fontWeight: 'bold'
    },
    default: {
      textAlign: "center",
      color: "white",
      fontFamily: "Halenoir Compact Text Bold",
      fontSize: 14,
      fontWeight: 'bold'
    }
  }),
  topLeftNavSection: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Regular",
      fontSize: 14,
      color: '#1B1B1B'
    },
    default: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 12,
      color: '#1B1B1B'
    }
  }),
  formTitleSection: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Medium",
      fontWeight: "bold",
      fontSize: 15,
      color: '#464545'
    },
    default: {
      fontFamily: "Halenoir Compact Text Medium",
      fontWeight: "500",
      fontSize: 15,
      color: '#1B1B1B'
    }
  }),
  notificationBox: {
    backgroundColor: '#EAF5F8',
    borderColor: '#CBEAF5'
  },
  notificationText: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Regular",
      fontSize: 14,
      color: '#5C5C5C'
    },
    default: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 14,
      color: '#1B1B1B'
    }
  }),
  formTextInput: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Medium",
      fontSize: 14,
      fontWeight: "500",
      color: '#1B1B1B'
    },
    default: {
      fontFamily: "Halenoir Compact Text Medium",
      fontSize: 14,
      fontWeight: "500",
      color: '#1B1B1B'
    }
  }),
  formBody: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Medium",
      fontSize: 14,
      color: '#5C5C5C'
    },
    default: {
      fontFamily: "Halenoir Compact Text Medium",
      fontWeight: "500",
      fontSize: 14,
      color: '#5C5C5C'
    }
  }),
  formBodyTotal: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Bold",
      fontWeight: 'bold',
      fontSize: 14,
      color: '#5C5C5C'
    },
    default: {
      fontFamily: "Halenoir Compact Text Bold",
      fontWeight: 'bold',
      fontSize: 14,
      color: '#5C5C5C'
    }
  }),
  subTitleText: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Bold",
      fontWeight: "bold",
      fontSize: 14,
      color: '#117AAA'
    },
    default: {
      fontFamily: "Halenoir Compact Text Bold",
      fontWeight: 'bold',
      fontSize: 14,
      color: '#117AAA'
    }
  }),
  formBodyNotBlack: Platform.select({
    web: {
      // fontFamily: "HalenoirCompactText-Regular",
      // fontSize: 14,
      // color: '#5C5C5C',
    },
    default: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 14,
      color: '#5C5C5C'
    }
  }),
  totalAndAmounts: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Regular",
      fontSize: 14,
      color: '#5C5C5C'
    },
    default: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 14,
      color: '#5C5C5C'
    }
  }),
  formLineWeight: Platform.select({
    web: {
      borderBottomWidth: 1,
      borderColor: '#DBDBDB'
    },
    default: {
      borderBottomWidth: 0.5,
      borderColor: '#DBDBDB'
    }
  }),
  formBoldLineWeight: Platform.select({
    web: {
      borderBottomWidth: 1,
      borderColor: '#5C5C5C'
    },
    default: {
      borderBottomWidth: 1,
      borderColor: '#5C5C5C'
    }
  }),
  buttonSubmitActionable: {
    backgroundColor: '#042F86'
  },
  buttonSubmitActionableText: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: 13,
    color: '#FFFFFF',
    textTransform: 'uppercase'
  },
  buttonDefault: {
    backgroundColor: '#003087'
  },
  buttonDefaultText: {
    fontFamily: "Montserrat",
    fontWeight: "500",
    fontSize: 13,
    color: '#FFFFFF',
    textTransform: 'uppercase'
  },
  buttonCancel: {
    backgroundColor: '#FFFFFF',
    borderColor: "#052F86",
    borderWidth: 1
  },
  buttonCancelText: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: 13,
    color: '#003087',
    textTransform: 'uppercase'
  },
  helperText: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Regular",
      fontSize: 14,
      color: '#8B8B8B'
    },
    default: {
      // fontFamily: "Halenoir Compact Regular",
      // fontSize: 14,
      // color: '#8B8B8B',
    }
  }),
  editCancelLinksOnVPP: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Bold",
      fontSize: 14,
      color: '#117AAA',
      fontWeight: 'bold'
    },
    default: {
      // fontFamily: "Halenoir Compact Regular",
      // fontWeight: "bold",
      // fontSize: 14,
      // color: '#117AAA',
    }
  }),
  activeTab: Platform.select({
    web: {
      backgroundColor: "#EAF5F8",
      borderWidth: 0
    },
    default: {
      backgroundColor: "#EAF5F8",
      borderWidth: 0
    }
  }),
  activeTabText: Platform.select({
    web: {
      fontFamily: "Halenoircompacttext-Bold",
      fontWeight: 'bold',
      fontSize: 14,
      color: '#10719E',
      textAlign: 'center'
    },
    default: {
      // Dont have in sheet
      fontFamily: "Halenoir Compact Text Bold",
      fontWeight: "bold",
      fontSize: 14,
      color: '#10719E',
      textAlign: 'center'
    }
  }),
  nonActiveTab: Platform.select({
    web: {
      backgroundColor: "#FFFFFF",
      borderColor: "#DDD",
      borderWidth: 1
    },
    default: {
      // Dont have in sheet
      backgroundColor: "#FFFFFF",
      borderColor: "#DDD",
      borderWidth: 1
    }
  }),
  nonActiveTabText: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Medium",
      fontSize: 14,
      color: '#1B1B1B',
      textAlign: 'center'
    },
    default: {
      fontFamily: "Halenoir Compact Text Medium",
      fontSize: 14,
      color: '#1B1B1B',
      textAlign: 'center'
    }
  }),
  clickableLink: Platform.select({
    web: {
      fontFamily: "Halenoircompacttext-Bold",
      fontSize: 14,
      color: '#10719E',
      fontWeight: 'bold'
    },
    default: {
      fontFamily: "Halenoir Compact Text Bold",
      fontWeight: "bold",
      fontSize: 14,
      color: '#10719E',
      textDecorationLine: "none"
    }
  }),
  clickableLinkMediumFont14: Platform.select({
    web: {
      fontFamily: "Halenoircompacttext-Medium",
      fontSize: 14,
      color: '#10719E',
      fontWeight: 'bold'
    },
    default: {
      fontFamily: "Halenoir Compact Text Bold",
      fontWeight: "bold",
      fontSize: 14,
      color: '#10719E',
      textDecorationLine: "none"
    }
  }),
  clickableLinkMedium: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Medium",
      fontSize: 11,
      color: "#4B4B4B",
      textDecoration: "underline"
    },
    default: {
      fontFamily: "HalenoirCompactText-Medium",
      fontSize: 11,
      color: "#4B4B4B",
      textDecoration: "underline"
    }
  }),
  footer: Platform.select({
    web: {
      backgroundColor: "#ECF9FE"
    },
    default: {
      backgroundColor: "#ECF9FE"
    }
  }),
  footerText: Platform.select({
    web: {
      fontFamily: "Roboto",
      fontSize: 11,
      color: '#707070'
    },
    default: {
      fontFamily: "Roboto",
      fontSize: 11,
      color: '#707070'
    }
  }),
  defaultTextTitle: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Bold",
      fontSize: 14,
      fontWeight: "bold",
      color: '#1B1B1B'
    },
    default: {
      fontFamily: "Halenoir Compact Text Bold",
      fontSize: 14,
      color: '#1B1B1B',
      fontWeight: 'bold'
    }
  }),
  defaultTextDescription: Platform.select({
    web: {
      fontFamily: "HalenoirCompactText-Regular",
      fontSize: 14,
      color: '#1B1B1B'
    },
    default: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 14,
      color: '#1B1B1B'
    }
  }),
  pennyContentText: {
    fontFamily: Platform.OS === 'web' ? "HalenoirCompactText-Regular" : "Halenoir Compact Regular",
    fontSize: 14,
    color: '#1B1B1B'
  },
  bannerViewWarning: {
    backgroundColor: '#FEFBE8',
    borderColor: '#F3D22F'
  },
  bannerViewSuccess: {
    backgroundColor: '#F5FAF5',
    borderColor: '#BCD9BF'
  },
  bannerViewError: {
    backgroundColor: '#E5B8B6',
    borderColor: '#E18A83'
  },
  modalTitle: {
    fontFamily: "Montserrat",
    fontSize: 22,
    fontWeight: '600',
    color: colors.secondary.softBlack
  },
  modalSubTitle: {
    fontFamily: "HalenoirCompactText-Bold",
    fontSize: 14,
    fontWeight: 'bold'
  },
  modalDesc: {
    fontFamily: "HalenoirCompactText-Regular",
    fontSize: 14
  },
  modalButtonText: {
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 'bold',
    color: "#FFFFFF",
    textTransform: 'uppercase'
  },
  communicationNotificationSectionTitle: {
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: '#454545'
  },
  accordionItem: {
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Montserrat",
    color: "#000000"
  },
  adTextTag: {
    fontFamily: "HalenoirCompactText-Regular",
    fontSize: 12,
    color: "#000000",
    textTransform: "uppercase",
    marginTop: 5
  },
  adTextTitle: {
    fontFamily: "Montserrat",
    fontSize: 22,
    fontWeight: 'bold',
    color: "#003087",
    marginTop: 5
  },
  adText: {
    fontFamily: "HalenoirCompactText-Regular",
    fontSize: 13,
    marginTop: 5,
    color: "#000000"
  },
  featuremodal: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    borderBottomColor: '#1B1B1B',
    paddingHorizontal: 8
  },
  disabled: {
    color: 'gray',
    opacity: 0.5
  }
};